import { createGlobalStyle } from "styled-components";
import Inter400 from "../fonts/Inter-400.woff2";
import Inter500 from "../fonts/Inter-500.woff2";
import HeadlandOne400 from "../fonts/HeadlandOne-400.woff2";

const GlobalStyle = createGlobalStyle`
@font-face {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${Inter400}) format('woff2');
}

@font-face {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(${Inter500}) format('woff2');
}

@font-face {
  font-family: 'Headland One';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${HeadlandOne400}) format('woff2');
}

html, body {
    font-family: ${({ theme }) => theme.fontFamily};
    padding: 0;
    margin: 0;
    font-size: 62.5%;
  }
  
  * {
    font-family: ${({ theme }) => theme.fontFamily};
    box-sizing: border-box;
  }
  
  // 30px
  h1 { 
    font-family: ${({ theme }) => theme.headingFontFamily};
    font-size: 3rem;
  }
  
  // 22.5px
  h2 { 
    font-family: ${({ theme }) => theme.headingFontFamily};
    font-size: 2.25rem;
  }
  
  // 17.5px
  h3 { 
    font-family: ${({ theme }) => theme.headingFontFamily};
    font-size: 1.75rem;
  }
  
  // 16px
  h4 { 
    font-family: ${({ theme }) => theme.headingFontFamily};
    font-size: 1.6rem;
  }
  
  // 16px
  div, span, blockquote, a, span, p { 
    font-size: 1.6rem;
  }  
`;

export default GlobalStyle;
